import React, { useEffect } from "react";
// import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import MobileNav from "../components/MobileNav";
import { motion } from "framer-motion";
import "./Exhibition.css";

// --- MOCK DATA ---
const EXHIBITIONS_DATA = [
  {
    id: 1,
    status: "UPCOMING",
    title: "The Silent Canvas",
    date: "Dec 10, 2025 – Jan 15, 2026",
    location: "National Art Gallery, New Delhi",
    description: "An immersive exploration of divine figures in modern contexts. This solo exhibition features the acclaimed 'Erawat' series and large-scale mythological murals.",
    image: "https://res.cloudinary.com/digze3wuc/image/upload/v1763389205/catagory_jukrvj.jpg", 
    ticketLink: "#"
  },
  {
    id: 2,
    status: "LAST DONE",
    title: "The Anjaan's World Frames",
    date: "March 05, 2026 – March 20, 2026",
    location: "Harnoor Palace, Bhopal",
    description: "A radical new collection focusing on texture and silence. Anjaan Vivek moves away from figures to explore abstract emotions through layers of oil and acrylic.",
    image: "https://res.cloudinary.com/digze3wuc/image/upload/v1779285903/IMG_20250916_182131367_zhwnnz.jpg",
    ticketLink: "#"
  }
];

const PAST_EXHIBITIONS = [
  {
    id: 101,
    year: "2024",
    title: "Roots & Rhythm",
    location: "Bharat Bhavan, Bhopal",
    image: "https://res.cloudinary.com/digze3wuc/image/upload/v1763312115/artist_paintings/kltumzkv5g8lr7ccn8np.png"
  },
  {
    id: 102,
    year: "2023",
    title: "Eternal India",
    location: "India Habitat Centre, Delhi",
    image: "https://res.cloudinary.com/digze3wuc/image/upload/v1763390594/erawat_p_tq3nhz.jpg"
  },
  {
    id: 103,
    year: "2022",
    title: "The First Stroke",
    location: "State Gallery of Art, Hyderabad",
    image: "/assets/Paintings/artist.jpg"
  }
];

const Exhibition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  return (
    <>
      <MobileNav />
      {/* <Navbar /> */}

      <div className="exhibitions-page">
        
        {/* --- HERO SECTION --- */}
        <section className="exhibition-hero">
          <div className="exhibition-hero-overlay">
            <motion.h1 
              initial={{ y: 30, opacity: 0 }} 
              animate={{ y: 0, opacity: 1 }} 
              transition={{ duration: 1 }}
            >
              Exhibitions & Events
            </motion.h1>
            <motion.p 
              initial={{ y: 30, opacity: 0 }} 
              animate={{ y: 0, opacity: 1 }} 
              transition={{ duration: 1, delay: 0.2 }}
            >
              Curating moments of awe across the globe
            </motion.p>
          </div>
        </section>

        <div className="exhibition-container">

          {/* --- SECTION: CURRENT & UPCOMING (Featured) --- */}
          <section className="featured-exhibitions">
            <motion.div 
                className="section-title"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
            >
                <span className="subtitle">On View</span>
                <h2>Current & Upcoming</h2>
            </motion.div>

            <div className="featured-list">
              {EXHIBITIONS_DATA.map((item) => (
                <motion.div 
                    className="featured-card" 
                    key={item.id}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeInUp}
                >
                  {/* Left: Image */}
                  <div className="featured-image-wrapper">
                    <img src={item.image} alt={item.title} />
                    <div className="date-badge">
                        {item.status}
                    </div>
                  </div>

                  {/* Right: Info */}
                  <div className="featured-info">
                    <span className="ex-date">{item.date}</span>
                    <h3>{item.title}</h3>
                    <div className="ex-location">
                        <i className="fa-solid fa-location-dot"></i>
                        <span>{item.location}</span>
                    </div>
                    <p>{item.description}</p>
                    {item.status == "CURRENT" || item.status == "UPCOMING" ?
                      <button className="btn-rsvp">
                        {item.status === "CURRENT" && "Plan Your Visit"} 
                        {item.status === "UPCOMING" && "Get Opening Invite"}
                    </button>
                    : null
                    }
                  </div>
                </motion.div>
              ))}
            </div>
          </section>

          {/* --- SECTION: PAST ARCHIVE (Grid) --- */}
          <section className="archive-section">
            <motion.div 
                className="section-title"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
            >
                <span className="subtitle">Archive</span>
                <h2>Past Exhibitions</h2>
            </motion.div>

            <motion.div 
                className="archive-grid"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                {PAST_EXHIBITIONS.map((ex) => (
                    <motion.div className="archive-card" key={ex.id} variants={fadeInUp}>
                        <div className="archive-img-box">
                            <img src={ex.image} alt={ex.title} />
                            <div className="archive-overlay">
                                <span>View Gallery</span>
                            </div>
                        </div>
                        <div className="archive-details">
                            <span className="archive-year">{ex.year}</span>
                            <h4>{ex.title}</h4>
                            <p>{ex.location}</p>
                        </div>
                    </motion.div>
                ))}
            </motion.div>
          </section>

          {/* --- NEWSLETTER / INVITE SECTION --- */}
          <motion.section 
            className="invite-section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <div className="invite-box">
                <i className="fa-regular fa-envelope-open"></i>
                <h3>Join the Guest List</h3>
                <p>Be the first to receive invitations to private viewings, artist talks, and new exhibition openings.</p>
                <div className="invite-form">
                    <input type="email" placeholder="Your Email Address" />
                    <button>Subscribe</button>
                </div>
            </div>
          </motion.section>

        </div>
      </div>
      <Footer1 />
    </>
  );
};

export default Exhibition;